export default "__VITE_ASSET__0a0afa73__"